export const NAME = 'visionCoverage'

export const GET_VISION_PLANS = 'clientBenefitsVisionGet'
export const POST_VISION_PLANS = 'clientBenefitsVisionPost'
